export default function() {
  return {
    name: 'customsGTM',
    /**
     * @function GTMScript
     * @description Adds GTM scripts.
     *
     * @param {object} payload
     * @param {string} event
     * @returns {void}
     */
    GTMScript: function (gtmID = "GTM-TN6ZLSR") {
      // Google Tag Manager
      if (window.google_tag_manager && window.google_tag_manager[gtmID]) {
        console.warn('Customs Tools: callIframeGTM - GTM script already defined');
        return;
      }

      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer',gtmID);
    }
  };
};
